import { defaultButtonProps } from "../../common/components/buttons/sxprops"


export const mainCont = {
    display: "flex",
    flexDirection: "column",
    width: '100%',
    height: "100%",
    overflow: "hidden",

}

export const tableCont = {
    height: "calc(100vh - 280px)",
}

export const headerCont = {
    //height: "64px",
    pb: "15px",
    width: "100%",
    alignItems: "start",
    justifyItems: "start",
    pt: {mobile: 2, tablet: 2},

}



export const addClientButton = (isMobile: boolean) => ({
    ...defaultButtonProps,
    overflow: "hidden",
    whiteSpace: "nowrap",
    height: "44px",
})

export const emptyCont = {
    height: "400px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
}

export const tableAction = {

}

export const ellipsisStyle = (isOpen: boolean) => ({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  maxWidth: "200px",
  color: isOpen ? "white" : "primary.main"
});